<script setup lang="ts">

import { useGameStore } from '@/stores/gameStore.ts'
import Backend from '@/models/backend.ts'
import { computed } from 'vue'
import ToggleSwitch from '@/components/Interface/ToggleSwitch/ToggleSwitch.vue'

/**
 * Props
 */
const props = defineProps<{
  newsType: string,
  status:string
}>();

/**
 * Stores
 */
const gameStore = useGameStore()

/**
 * function
 */
const toggleNewsItem = () => {
  const backend = new Backend();
  backend.toggleNotificationNewsType(props.newsType).then(() => {
    gameStore.setTinySuccessToastMessage('Notification toggled');
  });
}

const isEnabled = computed(() => props.status === 'enabled')

</script>

<template>
  <div class="flex justify-between items-center ps-2 rounded bg-slate-900 p-1 mb-1">
    <div>{{newsType}}</div>
    <div><ToggleSwitch :model-value="isEnabled" @update:model-value="toggleNewsItem" /></div>
  </div>
</template>

<style scoped lang="scss">

</style>